import React from 'react';
import { RetailerEntity } from 'src/modules/retailer/store/types';
import { BrandSpaceType } from 'src/modules/retailer';
import { useLocale } from 'src/modules/locale';
import { BrandSpacesListingStore } from '../../';
import {
  LayoutPageHeading,
  LayoutCardList,
  LayoutCardType,
  LayoutCardSize,
} from 'src/modules/layout';
import LayoutPage from 'src/modules/layout/components/page/LayoutPage';
import { useIntl } from 'react-intl';
import { BreadcrumbsProps } from 'src/modules/professionals/downloads/products/components/breadcrumbs/Breadcrumbs';
// import styles from './BrandSpaceListing.module.scss';

interface BrandSpaceListingPageProps extends BrandSpacesListingStore {
  breadcrumbs?: BreadcrumbsProps['links'];
  page: {
    link: string;
    stores: RetailerEntity[];
  };
}

const BrandSpaceListingPage: React.FunctionComponent<BrandSpaceListingPageProps> = (props) => {
  const intl = useIntl();
  const { getLocalizedObject } = useLocale();

  const pageProperties = {
    title: intl.formatMessage({ id: 'page/brand_spaces/head/page_title' }),
    description: intl.formatMessage({ id: 'page/designers/head/meta_description' }),
    breadcrumbs: props.breadcrumbs,
  };

  const {
    page: { link, stores },
  } = getLocalizedObject(props);

  // Sort by Country and city. Deprecated
  // brandSpaces = brandSpaces.sort(function (a, b) {
  //   if (a.country.name < b.country.name) {
  //     return -1;
  //   }
  //   if (a.country.name > b.country.name) {
  //     return 1;
  //   }
  //   if (a.city < b.city) {
  //     return -1;
  //   }
  //   if (a.city > b.city) {
  //     return 1;
  //   }
  //   return 0;
  // });
  return (
    <LayoutPage {...pageProperties}>
      <LayoutPageHeading
        titleKey="page/brand_spaces/listing/title"
        sublineKey="page/brand_spaces/listing/subline"
      />
      <LayoutCardList
        size={LayoutCardSize.Big}
        type={LayoutCardType.Overview}
        items={stores.map((brandSpace: any) => ({
          title: `${!!brandSpace?.city ? brandSpace?.city + ',' : ''} ${brandSpace?.country?.name}`,
          image: brandSpace?.image,
          caption: intl.formatMessage({
            id:
              brandSpace?.brandspace_type === BrandSpaceType.Headquarters
                ? 'page/brand_spaces/listing/headquarters_type'
                : 'page/brand_spaces/listing/brandspace_type',
          }),
          link: link + '/brand-spaces',
          slug: brandSpace?.slug,
        }))}
      />
    </LayoutPage>
  );
};

export default BrandSpaceListingPage;
